import React from 'react';

class TrackingPixel extends React.Component {
  constructor(props) {
    super(props);


    // used by React as the component name
    this.displayName = 'TrackingPixel';
  }


  /**
   * Renders component
   * @returns {ReactElement} ReactElement
   */
  render() {
    return (
      <div className='component-tracking-pixel'>
        <div className='tracking-pixel-wrapper'>
          <img
            src={this.props.trackingPixelUrl}
            alt='TRACKING PIXEL'
          />
        </div>
      </div>
    );
  }
}


/**
 * Expected propTypes
 * @prop {String} trackingPixelUrl - The tracking pixel url
 */
TrackingPixel.propTypes = {
  trackingPixelUrl: React.PropTypes.string,
};


export default TrackingPixel;



/** WEBPACK FOOTER **
 ** ./assets/js/src/components/TrackingPixel.jsx
 **/